import { useFeedback, useTranslation } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { stringToTag } from "@opendash/ui";
import { Modal, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { saveTicket } from "../..";
import { SourceSelect } from "../../../../_shared";
import { useTicketData } from "../../_shared";

type Props = {
  onSave?: (id: string) => void;
};

export const SourceSelectPopupIcon = observer((props: Props) => {
  const t = useTranslation();
  const ticketData = useTicketData();
  const { handleLoadingFeedback } = useFeedback();

  const [open, setOpen] = useState(false);
  const [selectedSource, setSelectedSource] = useState<string>(
    ticketData?.source?.id || ""
  );

  async function handleSourceChange(id: string) {
    setOpen(false);
    if (!id || id === ticketData?.source?.id) return;

    await handleLoadingFeedback(
      () => saveTicket({ existingTicketId: ticketData.ticket.id, source: id }),
      t("maintenance:ticket.source.change.loading"),
      t("maintenance:ticket.source.change.success"),
      t("maintenance:ticket.source.change.error")
    );

    props.onSave?.(id);
  }

  return (
    <>
      <Tooltip title={t("maintenance:ticket.source.change.tooltip")}>
        <Icon
          icon="fa:wrench"
          style={{ cursor: "pointer" }}
          onClick={() => setOpen(true)}
        />
      </Tooltip>

      <Modal
        title={stringToTag(
          t("maintenance:ticket.source.change.modal.title", {
            ticket: ticketData?.ticket?.get("title"),
          }),
          "'"
        )}
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => handleSourceChange(selectedSource)}
        okText={t("maintenance:ticket.source.change.modal.ok")}
        destroyOnHidden
      >
        <SourceSelect
          onChange={setSelectedSource}
          value={selectedSource}
          allowClear={false}
        />
      </Modal>
    </>
  );
});
